import Scroll from '../services/Scroll'
import EventBus from './EventBus'
import { EVENTS } from './Events'

export default function withScroll(Component, options) {
    options = {
        rootMargin: '50% 0% 50% 0%',
        //full = 0-1 (0 - zacina vjizdet element do viewportu, 1 - vyleze posledni pixel nahore)
        //bottom = 0-1 (0 - zacina vjizdet element do viewportu, 1 - je videt 100% elementu)
        ratioCalculation: 'full',
        ...options
    }
    return class extends Component {
        constructor(element) {
            super(element)

            this._scrollObserver = new IntersectionObserver(this._handleScrollIntersection, {
                threshold: 0,
                rootMargin: options.rootMargin
            })

            this._scrollRect = null
        }

        prepare() {
            super.prepare()

            setTimeout(() => {
                this._scrollObserver.observe(this.element)
            }, 0)

            EventBus.on(EVENTS.DOM_CHANGE, this._handleDomChange)
        }

        destroy() {
            super.destroy()

            this._scrollDetach()
            EventBus.off(EVENTS.DOM_CHANGE, this._handleDomChange)
        }

        _scrollAttach() {
            if (this.isAttached) {
                return
            }
            this._scrollResize()
            Scroll.on("resize", this._handleScrollResize)
            Scroll.on("scroll", this._handleScrollScroll)
            this.isAttached = true
            super.scrollEnter?.()
        }

        _scrollDetach() {
            if (!this.isAttached) {
                return
            }
            Scroll.off("resize", this._handleScrollResize)
            Scroll.off("scroll", this._handleScrollScroll)
            this.isAttached = false
            super.scrollLeave?.()
        }

        _handleScrollIntersection = (entries) => {
            entries.forEach((entry) => {
                if (entry.target !== this.element) {
                    return
                }
                if (entry.isIntersecting) {
                    this._scrollAttach()
                } else {
                    this._scrollDetach()
                }
            })
        }

        _handleScrollScroll = () => {
            this._scrollUpdate()
        }

        _handleScrollResize = () => {
            this._scrollResize()
        }

        _handleDomChange = () => {
            this._scrollResize()
        }

        _scrollUpdate() {
            if (!super.scroll) {
                return
            }

            let deltaTotal = Math.min(0, this._scrollRect.documentTop - Scroll.window.height)
            let deltaCurrent = 0

            if (options.ratioCalculation === 'bottom') {
                deltaTotal = -Scroll.window.height
                deltaCurrent = -Scroll.window.height
            }

            const total = Scroll.window.height + this._scrollRect.height + deltaTotal
            const current = this._scrollRect.documentTop - Scroll.getScroll().y + this._scrollRect.height + deltaCurrent

            const ratio = 1 - Math.max(Math.min(current / total, 1), 0)

            super.scroll(ratio)
        }

        _scrollResize() {
            const rect = this.element.getBoundingClientRect()
            this._scrollRect = {
                documentTop: Scroll.getScroll().y + rect.top,
                height: rect.height
            }

            super.scrollResize?.({
                rect: this._scrollRect
            })
            this._scrollUpdate()
        }


    }
}
